module.exports = __webpack_public_path__ + "static/media/gi.8bab78ca.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gi.svg
// module id = 657
// module chunks = 0